import { render, staticRenderFns } from "./content-wrapper.props.md?vue&type=template&id=441525f5&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../storefront/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports